import angular from 'angular';

angular.module('cloudX').directive('cxTransactionBar', [
  function() {
    return {
      restrict: 'E',
      //replace: true,
      template: require('./transactionBar.html'),
      scope: true,
      link: function(scope, element, attrs) {
        scope.limit = Number(attrs['limit']) || -1; //Default no limit
      },
      controller: [
        '$scope',
        'invoicingSvc',
        'invoiceDialogsSvc',
        function($scope, invoicingSvc, invoiceDialogsSvc) {
          $scope.data = invoicingSvc.getTransactions();
          invoicingSvc.reloadTransactions();

          $scope.linkTransaction = function(transaction) {
            invoiceDialogsSvc.newTransactionPayment(transaction, null).then(function() {
              invoicingSvc.reloadTransactions();
            });
          };
        },
      ],
    };
  },
]);
